var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSourceFossil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 24,
    height: 24,
    fill: "#FE4E45",
    fillRule: "evenodd",
    rx: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.585 18.522h.928v1.858h-13v-1.858h.928V12.95h-.928v-1.857h.928V5.522h-.928V3.665h13v1.857h-.928v5.571h.928v1.857h-.928v5.572M9.228 12.95a2.786 2.786 0 1 0 5.57 0c0-1.857-2.785-4.985-2.785-4.985s-2.785 3.128-2.785 4.985Z",
    style: {
      fill: "#000"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSourceFossil);
export default __webpack_public_path__ + "static/media/icon-source-fossil.a27fbef7fb2a0a89fcc2a5ee112da074.svg";
export { ForwardRef as ReactComponent };